import {otsBaseApi} from "../../ots-api";
import {
  PipelineFlowTransport,
  PipelineFlowTransportSearchCriteria
} from "../../../model/pipeline/pipeline-flow-transport";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['PipelineFlowTransports']})

const pipelineFlowTransportApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchPipelineActivity: builder.query<
      PipelineFlowTransport[],
      PipelineFlowTransportSearchCriteria
    >({
      query: (criteria) => ({
        url: '/pipeline-flow-transport/activity',
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(
              ({id}) => ({type: 'PipelineFlowTransports', id} as const)
            ),
            {type: 'PipelineFlowTransports', id: 'LIST'},
          ];
        } else {
          return [{type: 'PipelineFlowTransports', id: 'LIST'}];
        }
      },
    }),
    getAllPipelineFlowTransportsByReport: builder.query<
      PipelineFlowTransport[],
      string
    >({
      query: (reportId) => ({
        url: `/pipeline-flow-transport/all`,
        method: 'GET',
        params: {reportId: reportId},
      }),
      providesTags: (result, error, id) => [
        {type: 'PipelineFlowTransports', id},
      ],
    }),
    getPipelineFlowTransport: builder.query<PipelineFlowTransport, string>({
      query: (id) => ({
        url: `/pipeline-flow-transport/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "PipelineFlowTransports", id}]
    }),
    createPipelineFlowTransport: builder.mutation<PipelineFlowTransport, Partial<PipelineFlowTransport>>({
      query: (mapping) => ({
        url: "/pipeline-flow-transport",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "PipelineFlowTransports", id: "LIST"}]
    }),
    updatePipelineFlowTransport: builder.mutation<PipelineFlowTransport, Partial<PipelineFlowTransport>>({
      query: (mapping) => ({
        url: "/pipeline-flow-transport",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "PipelineFlowTransports", id}]
    }),
    deletePipelineFlowTransport: builder.mutation<void, Partial<PipelineFlowTransport>>({
      query: (mapping) => ({
        url: "/pipeline-flow-transport",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "PipelineFlowTransports", id}]
    })
  }),
})

export const {
  useSearchPipelineActivityQuery,
  useGetAllPipelineFlowTransportsByReportQuery,
  useGetPipelineFlowTransportQuery,
  useCreatePipelineFlowTransportMutation,
  useUpdatePipelineFlowTransportMutation,
  useDeletePipelineFlowTransportMutation,
} = pipelineFlowTransportApi;
